module.exports = __webpack_public_path__ + "img/border_long_radio.be8c448a.svg";